<template>
  <div>
    <h5 class="content-block">Check Validasi Tgl Pegawai</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <dl class="row">
          <dt class="col-sm-2">Import file excel data pegawai</dt>
          <dt class="col-sm-10">
            <input type="file" ref="fileInput" @change="handleFile" />
          </dt>
        </dl>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="dataGrid"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="nik"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :focused-row-enabled="true"
          :focused-row-index="0"
          @editing-start="editingStart"
          @option-changed="onPageChanged($event, 'dataGrid')"
        >
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />

          <DxEditing
            :allow-updating="true"
            :allow-deleting="false"
            :allow-adding="false"
            mode="batch"
          />
          <DxColumn type="buttons" :fixed="true" fixed-position="right">
            <DxButtonDatagrid name="edit" />
            <DxButtonDatagrid
              hint="Detail Pegawai"
              icon="search"
              :visible="true"
              @click="detailPegawai"
            />
          </DxColumn>

          <DxColumnFixing :enabled="true" />
          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn
            data-field="nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
          />
          <DxColumn
            data-field="nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
          />
          <DxColumn
            data-field="tmt"
            caption="tmt"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />
          <DxColumn
            data-field="tgl_mulai_bekerja"
            caption="tgl_mulai_bekerja"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />
          <DxColumn
            data-field="tgl_lahir"
            caption="tgl_lahir"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />
          <DxColumn
            data-field="pensiun_tgl"
            caption="pensiun_tgl"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />
        </DxDataGrid>
        <DxButton
          @click="compare()"
          text="Compare"
          type="default"
          class="validate"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import DxButton from "devextreme-vue/button";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import axios from "axios";
import notify from "devextreme/ui/notify";

// import ODataStore from "devextreme/data/odata/store";
// import DataSource from "devextreme/data/data_source";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxColumnFixing,
  DxButton as DxButtonDatagrid,

  // DxSummary,
  // DxTotalItem,
  // DxItem,
} from "devextreme-vue/data-grid";

import * as XLSX from "xlsx";

export default {
  components: {
    DxButton,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxPager,
    DxColumnFixing,
    DxButtonDatagrid,
  },
  data() {
    return {
      isDeleteDialogVisible: false,

      file: null,
      imageUrl: require("@/views/template_import_pegawai.png"),
      dataSource: null,
      numberingPageSize: 10,
      numberingPageNumber: 0,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",

      saveButtonOptions: {
        text: "Simpan Absen",
        type: "default",
        onClick: () => {
          //tambahkan ijazahfile ke array
          // this.ijazahFilePrep();
          this.isDeleteDialogVisible = false;
          this.dataGridSave();
        },
      },
    };
  },
  mounted() {},
  methods: {
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    async handleFile(e) {
      const files = e.target.files;
      const file = files[0];
      this.file = file;
      const self = this;
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: "binary",
          cellText: false,
          cellDates: true,
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        this.data = XLSX.utils.sheet_to_json(worksheet, {
          // header: 1,
          raw: false,
          dateNF: 'dd"/"mm"/"yyyy',
        });

        // this.data = XLSX.utils.sheet_to_json(worksheet, {});
        self.dataSource = this.data;
      };

      reader.readAsBinaryString(file);
    },

    async compare() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      // let dataFin = JSON.stringify(data);
      var data = {
        data: this.data,
      };

      await axios
        .post(`${API_BASE_URL}/check_tgl_pegawai`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          const data = XLSX.utils.json_to_sheet(response.data.data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, "data");
          XLSX.writeFile(wb, "Import Absen - data pegawai jgn diubah.xlsx");
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal download file pegawai", "error");
        });
    },
  },
};
</script>
